/**
 * Calculates the Stripe processing fee for a given amount.
 *
 * Standard Stripe US fee: 2.9% + $0.30 per successful card charge.
 * Both input and output are integer cents to avoid floating-point errors.
 *
 * Uses a gross-up formula so that after Stripe deducts its fee from the
 * charged total, the merchant nets exactly amountCents:
 *   total = ceil((base + 30) / (1 - 0.029))
 */
export function calculateStripeFee(amountCents: number): {
  feeCents: number;
  totalCents: number;
} {
  const totalCents = Math.ceil((amountCents + 30) / (1 - 0.029));
  const feeCents = totalCents - amountCents;
  return { feeCents, totalCents };
}

export interface RegistrationSummary {
  baseCents: number;
  feeCents: number;
  totalCents: number;
}

/**
 * Calculates a registration cost breakdown for one or more attendees.
 * When withConvenienceFee is true, grosses up via calculateStripeFee so the
 * org nets the base amount after card processing fees.
 */
export function calculateRegistrationSummary(
  registrationFee: number,
  qty: number,
  withConvenienceFee: boolean,
): RegistrationSummary {
  const baseCents = Math.round(registrationFee * 100) * qty;
  if (withConvenienceFee) {
    const { feeCents, totalCents } = calculateStripeFee(baseCents);
    return { baseCents, feeCents, totalCents };
  }
  return { baseCents, feeCents: 0, totalCents: baseCents };
}
